MW.elements.$main = $('div.page__content');
MW.elements.$trackingData = $('.tracking-data');
MW.elements.$tracking = $('.tracking');
MW.elements.$modal = $('#modal');
